import { XHtml } from "@/components/xhtml";
import { Heading } from "@digdir/designsystemet-react";
import type { TopicNewsListBlockProps } from "./types";

export type { TopicNewsListBlockProps };

export const TopicNewsListBlock = ({
  heading,
  newsPages,
}: TopicNewsListBlockProps) => {
  return (
    <div className=" flex flex-col gap-4">
      <Heading data-size="xl">{heading}</Heading>
      <div className="flex flex-col gap-4">
        {newsPages?.map((item, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          <div key={index}>
            <Heading data-size="lg">{item.heading}</Heading>
            <p>{item.startPublish}</p>
            <div className=" line-clamp-3 ">
              <XHtml xhtmlString={item.mainBody ?? ""} />
            </div>

            {item?.image?.source && (
              <div>
                <img src={item.image.source} alt={item.image.alternateText} />
              </div>
            )}
          </div>
        ))}
      </div>
      <ul className=" list-disc">
        {newsPages?.map((newsPage) => (
          <li key={newsPage.heading}>
            {/* TODO: Add link to news page */}
            <a
              // biome-ignore lint/a11y/useValidAnchor: <explanation>
              href="#"
              className="flex flex-row gap-2 text-blue no-underline hover:underline"
            >
              <span>{newsPage.startPublish}</span>
              <span>{newsPage.heading}</span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
